/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------*/
export default [
  {
    url: '/builder',
    name: "Course Builder",
    slug: "DigiCourseBuilder",
    icon: "Share2Icon",
    i18n: "CourseBuilder",
  },
  {
    url: '/backgrounds',
    name: 'Backgrounds',
    slug: "DigiBackgrounds",
    icon: "ImageIcon",
    i18n: "Background",
  },
  {
    url: '/music',
    name: "Audio / Podcasts",
    slug: "DigiMusic",
    icon: "MusicIcon",
    i18n: "Music",
  },
  {
    url: '/scenes',
    name: "Scenes",
    slug: "DigiScenes",
    icon: "FilmIcon",
    i18n: "Scene",
  },
  {
    url: '/navigations',
    name: "Navigation Maps",
    slug: "DigiNavigationMaps",
    icon: "MapIcon",
    i18n: "Navigation",
  },
  {
    url: '/characters',
    name: "Characters",
    slug: "DigiCharacters",
    icon: "SmileIcon",
    i18n: "Characters",
  },
  {
    url: '/videos',
    name: "Videos",
    slug: "DigiVideos",
    icon: "VideoIcon",
    i18n: "Video",
  },
  {
    url: '/ispringquizzes',
    name: "iSpring Quizzes",
    slug: "DigiISpringQuizzes",
    icon: "CheckSquareIcon",
    i18n: "iSpringQuiz",
  },
  {
    url: '/ispringpresentations',
    name: "iSpring Presentations",
    slug: "DigiISpringPresentations",
    icon: "LoaderIcon",
    i18n: "iSpringPresentation",
  },
  {
    url: '/documents',
    name: "Documents",
    slug: "DigiDocuments",
    icon: "FileTextIcon",
    i18n: "Document",
  },
  {
    url: '/quizlist',
    name: "Quizzes",
    slug: "DigiQuizzes",
    icon: "EditIcon",
    i18n: "Quiz",
  },
  
]
